export const REQUEST_PRIVACY_POLICY = 'REQUEST_PRIVACY_POLICY';

export function requestPrivacyPolicy() {
  return {type: REQUEST_PRIVACY_POLICY};
}

export const RECEIVE_PRIVACY_POLICY = 'RECEIVE_PRIVACY_POLICY';

export function receivePrivacyPolicy(accepted) {
  return {
    type: RECEIVE_PRIVACY_POLICY,
    accepted,
  };
}

export const REQUEST_ACCEPT_PRIVACY_POLICY = 'REQUEST_ACCEPT_PRIVACY_POLICY';

export function requestAcceptPrivacyPolicy() {
  return {type: REQUEST_ACCEPT_PRIVACY_POLICY};
}

export const RECEIVE_ACCEPT_PRIVACY_POLICY = 'RECEIVE_ACCEPT_PRIVACY_POLICY';

export function receiveAcceptPrivacyPolicy() {
  return {type: RECEIVE_ACCEPT_PRIVACY_POLICY};
}

export function fetchPrivacyPolicy() {
  return (dispatch, getState, {internalApi}) => {
    dispatch(requestPrivacyPolicy());
    return internalApi
      .policy()
      .then(response => response.json())
      .then(({accepted}) => dispatch(receivePrivacyPolicy(accepted)));
  };
}

function shouldFetchPrivacyPolicy({privacyPolicy}) {
  return privacyPolicy.accepted === null;
}

export const _shouldFetchPrivacyPolicy = shouldFetchPrivacyPolicy; // For testing

export function fetchPrivacyPolicyIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchPrivacyPolicy(getState())) {
      return dispatch(fetchPrivacyPolicy());
    }
    return Promise.resolve();
  };
}

export function acceptPrivacyPolicy() {
  return (dispatch, getState, {internalApi}) => {
    dispatch(requestAcceptPrivacyPolicy());
    return internalApi.acceptPolicy()
      .then(() => dispatch(receiveAcceptPrivacyPolicy()));
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/privacyPolicy.js